import { User } from './User';

export class SignUpUser extends User {
  confirmPassword!: string;
  password!: string;
}
